import React from 'react';
import { Trans } from 'next-i18next';
import { NewWidgetAlert } from 'views/rebranded-module/common/components/UI/NewMainWidget/NewWidgetAlert';
import StyledWrapper, {
  StyledLink,
} from 'views/common/components/UI/MainWidget/TourOnlyNotice/TourOnlyNotice.styles';

const TourOnlyNotice = (props) => {
  const { slug, variant = 'default' } = props;

  return (
    <StyledWrapper variant={variant}>
      <NewWidgetAlert
        alertMassage={(
          <Trans
            i18nKey="tour_only_notice"
            ns="fe_er_common_main_widget"
            components={{
              prefix: <strong />,
              // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label
              toursLink: (
                <StyledLink
                  href={`/motorcycle-tours/${slug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
        )}
      />
    </StyledWrapper>
  );
};

export { TourOnlyNotice };
